import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');


const RenderWpForm = () => {

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");	

//var boolFetchingSads=false;

const navigate = useNavigate();


const [dowait, setDowait] = useState({show:false});
const [wptapps, setWptapps] = useState([]);
const [createuseroptions, setCreateuseroptions] = useState([]);
const [deferoptions, setDeferoptions] = useState([]);
const [deferreasons, setDeferreasons] = useState([]);
const [emlmsgs, setEmlmsgs] = useState([]);

const [crit, setCrit]= useState({CREATE_USER:"", TBL_LOADED:false, EML_MSG:"", DEFER_REASON:"", ACTION_FLAG:""});

//tblwptapps

const location = useLocation();


useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "Cancel Applications";	

getcreateuseroptions();
getdeferreasons();

 },[]);

useEffect(() => {

if (crit.TBL_LOADED==true)	
	getappsforcancel();

 },[crit.CREATE_USER]);
 
 useEffect(() => {

//console.log(JSON.stringify(crit));

 },[crit]);

useEffect(() => {

//document.getElementById("button1").style.visibility=wptapps.length==0?"hidden":"visible";

 },[JSON.stringify(wptapps)]);

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


async function getappsforcancel(){
		setWptapps([]);
		
		if (crit.CREATE_USER=="")
			return;
		
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), CREATE_USER:crit.CREATE_USER} )
  };		

  await fetch(resturl+'rarwpform/getappsforcancel',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetappsforcancel(res) )	
	
}//end func

function aftergetappsforcancel(res){
	
console.log("aftergetappsforcancel: "+res.length);

if (!res.length)
	return;

let temp=[];

res.map((col, index) => {
	//if (index==0){
	const MPR_NAME=col['MPR_NAME'];
	
	const appid=col['WPT_APP_ID'];
	const trkey="tblwptapp_tr_"+index;
	const cbkey="tblwptapp_cb_"+index;
	
	temp.push(<tr key={trkey} >
	<td align='right' >{""+(1+index)}</td>
	<td align='left' >{col['WPT_STATUS']}</td>
	<td align='left' >{col['AGENCY']}</td>
	<td align='left' >{MPR_NAME}</td>
		{/*<td align='left' >{col['MPR_TEL_NBR']}</td>*/}
	<td align='left' >{col['IMG_REF']}</td>
	<td align='left' >
		<input type="checkbox" name="WPT_APP_ID[]" defaultValue={appid} id={cbkey} />
		<label htmlFor={cbkey} className="hand" >{col['MPE_NAME']}</label>
		<input name="IMG_REF[]" defaultValue={col['IMG_REF']} type="hidden" />
		<input name="MPE_NAME[]" defaultValue={col['MPE_NAME']} type="hidden" />
		<input name="MPE_OCCUPATION[]" defaultValue={col['MPE_OCCUPATION']} type="hidden" />
		<input name="SUBMITTED[]" defaultValue={col['SUBMITTED_TO_CSC']} type="hidden" />
		</td>
	<td align='left' >{col['MPE_OCCUPATION']}</td>
		{/*<td align='right' className="tooltip" >{voucherLink}&nbsp;</td>*/}
	<td align='center' >{col['SUBMITTED_TO_CSC']}</td>
	</tr>);	
	
	});
	
setWptapps(temp);	

}//end func



async function getdeferreasons(){
		
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

  await fetch(resturl+'rarwpform/getdeferreasons',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetdeferreasons(res) )	
	
}//end func


function aftergetdeferreasons(res){
console.log("aftergetdeferreasons: "+res.length);
if (!res.length)
	return;

let options=[], emlmsgs=[], reasons=[];

res.map((col, index) => {
	const DEFER_REASON=col['DEFER_REASON'];
	const key="user_"+index;
	
	options.push(<option key={key} value={DEFER_REASON} >{DEFER_REASON}</option>);
	emlmsgs.push(col['EML_MSG']);
	reasons.push(col['DEFER_REASON']);
	});
		
setDeferoptions(options);
setDeferreasons(reasons);
setEmlmsgs(emlmsgs);
}//end func
	

async function getcreateuseroptions(){
		
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), CREATE_USER:""} )
  };		

  await fetch(resturl+'rarwpform/getappsforcancel',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetcreateuseroptions(res) )	
	
}//end func

function aftergetcreateuseroptions(res){
console.log("aftergetcreateuseroptions: "+res.length);
if (!res.length)
	return;

let options=[];
res.map((col, index) => {
	const CREATE_USER=col['CREATE_USER'];
	const key="user_"+index;
	
	options.push(<option key={key} value={CREATE_USER} >{CREATE_USER}</option>);
	});
		
setCreateuseroptions(options);
}//end func


async function submitform1(e){
	
	e.preventDefault();

	const flag=crit.ACTION_FLAG;
	
	if (!document.getElementsByName("WPT_APP_ID[]"))
		return;
	
	let ARR_APP_ID=[], arrElem=document.getElementsByName("WPT_APP_ID[]");
	let ARR_MPE_OCCUPATION=[], ARR_MPE_NAME=[], ARR_IMG_REF=[], ARR_SUBMITTED=[];
	const len=arrElem.length;
	
	const phrase=(flag=='d')?"deferred":"cancelled";
	
	for (var i=0; i<len; i++){
		const currElem=arrElem[i];
		if (currElem.checked==true){
			ARR_APP_ID.push(currElem.value);
			ARR_IMG_REF.push(document.getElementsByName("IMG_REF[]")[i].value);
			ARR_MPE_NAME.push(document.getElementsByName("MPE_NAME[]")[i].value);
			ARR_MPE_OCCUPATION.push(document.getElementsByName("MPE_OCCUPATION[]")[i].value);
			ARR_SUBMITTED.push(document.getElementsByName("SUBMITTED[]")[i].value);
			}
			
		}//end for	

	if (ARR_APP_ID.length==0){
		alert("select the applications first");
		return;
		}
		
	const result=await window.confirm(ARR_APP_ID.length+" application(s) will be "+phrase+".  are you sure?");
	
	if (!result)
		return;

	const form1=document.getElementById("form1");
	// This is the important part, test if form is valid
	if (form1.checkValidity() === false){
		// This is the magic function that displays the validation errors to the user
		form1.reportValidity();   
		return; 
		}//end if
	
	
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, ARR_APP_ID:ARR_APP_ID
		, ARR_SUBMITTED:ARR_SUBMITTED
		, ARR_IMG_REF:ARR_IMG_REF
		, ARR_MPE_NAME:ARR_MPE_NAME
		, ARR_MPE_OCCUPATION:ARR_MPE_OCCUPATION
		, CREATE_USER: crit.CREATE_USER
		, DEFER_REASON: crit.DEFER_REASON
		, EML_MSG: crit.EML_MSG
		, STATUS: (flag=='d')?"NOTSUBMIT":"CANCELLED"
		};	
	//crit.DEFER_REASON
	deferorcancel(e, params, phrase);
	
}//end func	
	
async function deferorcancel(e, params, phrase){
		
	//crit.DEFER_REASON
	//console.log(JSON.stringify(params));
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowait({show:true});

  await fetch(resturl+'rarwpform/deferorcancelwptapps',requestOptions)
      .then(res => res.json())
      .then(res => 	afterdeferorcancel(res, phrase) )	
	
}//end func

	
function afterdeferorcancel(res, phrase){
	
	setDowait({show:false});
	
	let UPDATE_COUNT=0;
	
	if (res.length)
		if (res.length==1)
			UPDATE_COUNT=res[0].UPDATE_COUNT;
	
	if (UPDATE_COUNT>0){
		showsnackbar("updated complete: "+UPDATE_COUNT+" application(s) "+phrase);
		getappsforcancel();
		}
	else
		showsnackbar("that failed!  please try again or contact admin");
	
	
}//end func

function handleChange(e){
const {name, value}	=e.target;
console.log("handleChange: "+name+" "+value);
	
if (name=="DEFER_REASON"){
	let emlMsg="";
	for (var i=0; i<deferreasons.length; i++)
		if (deferreasons[i]==value)
			emlMsg=emlmsgs[i];
			
	setCrit((prev)=>{
		return {...prev, [name]:value, EML_MSG:emlMsg}
	});
	}//end if
else
	setCrit((prev)=>{
		return {...prev, TBL_LOADED:true, [name]:value}
	});
	
}//end func

function nofunc(){
}


  return (
    <>
	<div align='center' style={{marginTop:"12px"}} >
	<span style={{color:"brown"}} >not all applications qualify for defer or cancellation.  The criteria are listed below:</span>
	<ul style={{paddingTop:"0px", marginLeft:"auto", marginRight:"auto", width:"45%"}} >
	<li align='left' >the application has been submitted on the portal</li>
	<li align='left' >the application does not have paid receipts associated</li>
	<li align='left' >the application has not been updated or advanced for 3 working days</li>
	</ul>
	</div>

<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}} >
<table align="center" border="0" >
<tbody>
<tr>
	<td align="center" >
	<select name="CREATE_USER" required onChange={(e)=>{handleChange(e);}} >
	<option value='' key="user_0" >* * * select create user * * * </option>
	{createuseroptions}
	</select>
	</td>
	<td align="left" rowSpan="3" >
	Email Message to Customer:
	<br/><textarea name="EML_MSG" cols="50" rows="6" required onChange={(e)=>{handleChange(e);}} value={crit.EML_MSG} placeholder="select a reason from the list or type a reason here" ></textarea>
	</td>
</tr>

<tr>
	<td align="center" >
	<select name="DEFER_REASON" onChange={(e)=>{handleChange(e);}} value={crit.DEFER_REASON}  >
	<option value='' key="user_0" >* * * defer/cancel reasons * * * </option>
	{deferoptions}
	</select>
	</td>
</tr>

<tr>
<td align="center">

	{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
	{
	!dowait.show && <>
	<button className='button'  name="ACTION_FLAG" value='d'  onClick={(e)=>{handleChange(e);}}  >defer applications</button>
	&nbsp;&nbsp;
	<button className='button'  name="ACTION_FLAG" value='c' onClick={(e)=>{handleChange(e);}}  >cancel applications</button>
	</>
	}	

</td>
</tr>



</tbody>
</table>
</form>

<div align="center" > 
after applications are <span style={{fontWeight:"bold",color:"brown"}} >deferred</span> on this page, they can be corrected as needed and then resubmitted.
<br/><span style={{fontWeight:"bold",color:"brown"}} >Not so when cancelled</span>
</div>

	<table align='center' className="customers" style={{width:"85%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>status</th>
		<th>agency</th>
		<th>employer's name</th>
		{/*<th>employer's phone #</th>*/}
		<th>immig. ref. #</th>
		<th>applicant</th>
		<th>job title</th>
		<th>submitted</th>
	</tr>
	</thead>
	<tbody>
	{wptapps}
	</tbody>
	</table>
	

<div id="snackbar">&nbsp;</div>
    </>
  );
  



};



export default RenderWpForm;